import { LoaderFunctionArgs } from '@remix-run/node'
import { typedjson, useTypedLoaderData } from 'remix-typedjson'
import { ActivityItemList } from '~/domain/activity/components/ActivityItemList/ActivityItemList'
import { GetUserActivitiesUseCase } from '~/domain/activity/usecases/GetUserActivitiesUseCase'
import { authenticator } from '~/domain/auth/services/authService'
import { Alert } from '~/application/components/Alert/Alert'

export async function loader({ params, request }: LoaderFunctionArgs) {
  const id = params.id
  const userId = await authenticator.isAuthenticated(request)

  if (id === undefined) {
    throw new Response('Not Found', { status: 404 })
  }

  const getUserActivitiesUseCase = GetUserActivitiesUseCase.create()
  const result = await getUserActivitiesUseCase.execute(
    userId,
    parseInt(id, 10),
  )

  if (result.isErr()) {
    throw new Error('Activities not found')
  }

  const data = result.value

  return typedjson({
    ...data,
  })
}

export default function UserActivities() {
  const data = useTypedLoaderData<typeof loader>()

  return (
    <>
      {data.data.length > 0 ? (
        <ActivityItemList
          activities={data.data}
          page={1}
          pageTotal={data.pageTotal}
        />
      ) : (
        <Alert>活動報告がありません</Alert>
      )}
    </>
  )
}
